import { Component, Input, OnInit } from '@angular/core';
import { CbicContentMst, ICbicContentMst } from '../../cbic-content-mst.model';
import { UtilsService } from '../../../../core/util/view-file.component';
import { ChangeLanguageService } from 'app/core/util/change-language.service';

@Component({
  selector: 'cbic-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss']
})
export class TilesComponent implements OnInit {
  @Input() data: ICbicContentMst | undefined;
  constructor(
    public utils: UtilsService,
    private changeLnService: ChangeLanguageService,
  ){}
  ngOnInit(): void {
    console.log("");
  }
  viewFile(filepath: any) {
    this.utils.viewOpenning(filepath);  
  }
  hasInfo(content: CbicContentMst): boolean{
    if(this.changeLnService.getLanguage() === 'hi' && content.infoHi){
      return true;
    }else if(content.infoEn){
      return true;
    }
    return false;
  }
}
